/**
 * **The `itemInfo` keys that hold an institution's name exactly as a document
 * wrote it, per inventory type** (VALE-1940).
 *
 * The frontend twin of the backend's `VERBATIM_INSTITUTION_NAME_FIELDS`
 * (`backend/src/institutions/constants/verbatim-institution-name-fields.constants.ts`),
 * which is what the field registry's `machine` class is bound to. The package
 * boundary means it cannot be imported, so it is mirrored here and the parity
 * test (`item-info-field-registry-parity.test.ts`) fails the moment the two
 * disagree: edit the backend first, then this.
 *
 * Each is saved but never its own row. The type's institution row represents
 * it, and claims the key so a change to the verbatim name marks that row
 * (`inventoryBlocks`).
 */
export const VERBATIM_INSTITUTION_NAME_FIELDS: Readonly<
  Record<string, readonly string[]>
> = {
  superannuation: ['fundName'],
  'managed-funds': ['fundName'],
  'srn-shares': ['shareRegistry'],
  mortgage: ['lenderName'],
  'vehicle-loan': ['lenderName'],
  'personal-loan': ['lenderName'],
  'utility-bill': ['providerName'],
  'legal-professional': ['serviceProviderName'],
  'funeral-burial': ['funeralProviderName'],
  'other-liability': ['creditorName'],
  cryptocurrency: ['cryptocurrencyExchangeName']
};
